// UserHomeTemplateコンポーネントをインポート
// ユーザー向けの「ホーム」ページ用テンプレートとして使用
import UserHomeTemplate from "../templates/UserHomeTemplate";
import PreventBackButton from "../../components/PreventBackButton";

/**
 * UserHomePageコンポーネント
 * ユーザー向けの「ホーム」ページを表示するためのコンポーネント
 * UserHomeTemplateを利用して、ホーム画面を構築
 */
const UserHomePage: React.FC = () => {

    // ホームページテンプレートをレンダリング
    // 特別なプロパティを渡さず、UserHomeTemplateをそのまま利用
    return (
        <>
            <PreventBackButton />
            <UserHomeTemplate />
        </>
    );
};

// UserHomePageコンポーネントをデフォルトエクスポート
// 他のファイルからこのコンポーネントをインポートして利用可能にする
export default UserHomePage;
